import script from "./TaskCategoriesTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCategoriesTabs.vue?vue&type=script&setup=true&lang=js"

import "./TaskCategoriesTabs.vue?vue&type=style&index=0&id=f67ab268&lang=scss"

const __exports__ = script;

export default __exports__